module.exports = __webpack_public_path__ + "img/77.7d1ea2fb.png";